<template>
  <div class="d-flex justify-center" :style="{ padding: '10px', width: '90%' }">
    <step1 v-if="step == 1" />
    <step2 v-if="step == 2" />
    <step3 v-if="step == 3" />
    <step4 v-if="step == 4" />
    <step5 v-if="step == 5" />
    <step6 v-if="step == 6" />
    <step7 v-if="step == 7" />
  </div>
</template>

<script>
export default {
  components: {
    step1: () => import('../../components/register/step1.vue'),
    step2: () => import('../../components/register/step2.vue'),
    step3: () => import('../../components/register/step3.vue'),
    step4: () => import('../../components/register/step4.vue'),
    step5: () => import('../../components/register/step5.vue'),
    step6: () => import('../../components/register/step6.vue'),
    step7: () => import('../../components/register/step7.vue'),
  },
  computed: {
    step() {
      return this.$store.state.register.step;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.step != 7) {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      );
      if (answer) {
        this.$store.commit('register/clearData');
        next();
      } else {
        next(false);
      }
    } else {
      this.$store.commit('register/setReferenceNumber', '');
      this.$store.commit('register/setStep', 1);
      next();
    }
  },
};
</script>
